<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="900px"
  >
    <v-card>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Tài khoản chuyên gia</v-toolbar-title>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-data-table
          v-if="items.length > 0"
          :loading="loading"
          loading-text="Đang tải dữ liệu... Vui lòng chờ"
          :headers="headers"
          :items="items"
          item-key="name"
          :footer-props="{
            showFirstLastPage: true
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-radio-group 
              v-model="selectedAccount" 
              hide-details 
              class="select-account"
            >
              <v-radio :value="item.id"/>
            </v-radio-group>
          </template>
        </v-data-table>
        <span v-else>Không tìm thấy tài khoản phù hợp!</span>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        loading: false,
        accountSelected: [],
        selectedAccount: null,
        dialog: false,
        errors_exist: false,
        errors: [],
        headers: [
          { text: 'Chọn', value: 'id' },
          { text: 'Tên', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Tên tài khoản', value: 'info.username' }
        ],
        items: []
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist = false;
        if (this.showDialog) {
          this.dialog = true;
          this.getListItems();
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getListItems() {
        const app = this;
        app.loading=true;
        axios.get("api/v1/users-is-expert")
          .then(response => {
            app.items = response.data;
            app.loading=false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(){
        const app = this;
        let id = app.item.id;
        let users = 0;
        let data = {};

        if(app.selectedAccount){
          users = app.selectedAccount;
        }

        data.users = users;

        let method = "post";
        let url = `api/v1/experts-set-account/${id}`;

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>
<style>
  .select-account.v-input--selection-controls{
    margin-top: 0px;
    padding-top: 0px;
  }
</style>